module.exports = __webpack_public_path__ + "img/Architectures_M.0b409be1.svg";